// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const userSlice = (set: any, ...rest: any) => ({
  user: null,
  setUser: (data: any) =>
    set(() => ({
      user: data
    })),
  logout: () => set(() => ({ user: null }))
});
